import { ReactElement, ReactNode } from 'react';
import { connect } from 'react-redux';
import {
	Redirect,
	Route,
	RouteComponentProps,
	StaticContext
} from 'react-router';

import { AppState } from '../../../redux';

export interface IGuardedRouteOwnProps {
	exact?: boolean;
	path: string;
	children?: ReactNode;
	render?:
		| ((
				props: RouteComponentProps<
					{
						[x: string]: string | undefined;
					},
					StaticContext,
					unknown
				>
		  ) => ReactNode)
		| undefined;
}

export interface IGuardedRouteStateProps {
	userLicences?: string[];
}

function GuardedRouteComponent(
	props: IGuardedRouteOwnProps & IGuardedRouteStateProps
): ReactElement {
	const { exact, path, children, render, userLicences } = props;

	function isWildcardUser(): boolean {
		return (
			userLicences !== undefined &&
			userLicences.length === 1 &&
			userLicences[0] === '*'
		);
	}

	function CreateRoute(): ReactElement {
		if (!isWildcardUser()) return <Redirect to="/" />;
		return (
			<Route exact={exact} path={path} render={render}>
				{children}
			</Route>
		);
	}

	return <>{userLicences && CreateRoute()}</>;
}

function mapStateToProps(state: AppState) {
	return {
		userLicences: state.user.licences
	};
}

export const GuardedRoute = connect(mapStateToProps)(GuardedRouteComponent);
